import { render, staticRenderFns } from "./MentorDescription.vue?vue&type=template&id=a8d54856&scoped=true&"
import script from "./MentorDescription.vue?vue&type=script&lang=js&"
export * from "./MentorDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d54856",
  null
  
)

export default component.exports